import React from 'react';

import { TydeMenuButton } from 'broentech';

import AccountTreeIcon from '@mui/icons-material/AccountTree';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import PeopleIcon from '@mui/icons-material/People';
import SensorsIcon from '@mui/icons-material/Sensors';
import WorkIcon from '@mui/icons-material/Work';

import { UserListPage } from 'pages/UserListPage';
import { TimeseriesPage } from 'pages/TimeseriesPage';
import { PortfoliosPage } from 'pages/PortfoliosPage';
import { ContextManagerPage } from 'pages/ContextManagerPage';

type TydeMenuButtonWithPage = {
  page: JSX.Element;
  headerTitle?: string;
} & TydeMenuButton

export const menuItems: TydeMenuButtonWithPage[] = [
  {
    route: '/portfolios',
    title: 'Portfolios',
    icon: () => <FolderSpecialIcon fontSize="large" />,
    page: <PortfoliosPage />,
  },
  {
    route: '/users',
    title: 'Users',
    icon: () => <PeopleIcon fontSize="large" />,
    page: <UserListPage />,
  },
  {
    route: '/timeseries',
    title: 'Timeseries',
    headerTitle: 'Timeseries Management',
    icon: () => <SensorsIcon fontSize="large" />,
    page: <TimeseriesPage />,
  },
  {
    route: '/context',
    title: 'Context',
    headerTitle: 'Context Manager',
    icon: () => <AccountTreeIcon fontSize="large" />,
    page: <ContextManagerPage />,
  },
  {
    route: '',
    title: 'HydroQ',
    headerTitle: 'HydroQ',
    icon: () => <WorkIcon fontSize="large" />,
    clickHandler: () => {
      window.open(window.location.origin + '/hydroq');
    },
    page: (<> </>),
  },
];
